<template>
  <div class="rightChart">
    <div class="twoGraphBox">
      <div class="lefBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">各省市裁判文书数量分布情况</div>
        </div>
        <!-- 地图 -->
        <div id="map" class="newgraph_box"></div>
      </div>
      <div class="ritBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">各个省市裁判文书数量排名 top10</div>
        </div>
        <!-- 横向柱图 -->
        <div id="thin1" class="newgraph_box"></div>
      </div>
    </div>

    <div class="twoGraphBox">
      <div class="lefBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">审理法院发布文书数量TOP5</div>
        </div>
        <!-- 饼图 -->
        <div id="thin2" class="newgraph_box"></div>
      </div>
      <div class="ritBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">案由种类数量分布TOP10</div>
        </div>
        <!-- 柱图 -->
        <div id="graph" class="newgraph_box"></div>
      </div>
    </div>

    <div class="twoGraphBox">
      <div class="lefBox cir">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">法院层级裁判文书数量分布</div>
        </div>
        <!-- 饼图 -->
        <div id="graph2" class="newgraph_box"></div>
      </div>
      <div class="lefBox cir">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">文书类型数量分布</div>
        </div>
        <!-- 饼图 -->
        <div id="graph3" class="newgraph_box"></div>
      </div>
      <div class="lefBox cir">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">案件类型数量分布</div>
        </div>
        <!-- 纵向柱图 -->
        <div id="graph4" class="newgraph_box"></div>
      </div>
    </div>

    <!-- 时间线 -->
    <div class="bottom_timeLine">
      <div id="timeLine3"></div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import echarts from "echarts";
import chinaJson from "../../static/common/china.json";
export default {
  data() {
    return {
      xAxis_data: [],
      moveYearsList: [], //时间轴数据
      series_data: [],
      timeLine3: null
    };
  },
  props: ["initEchart"],
  watch: {
    initEchart(n, o) {
      this.init();
      this.timeLine3.resize();
    }
  },
  methods: {
    // 图一-中国地图
    map(year) {
      var mapList = [];
      var myMap = echarts.init(document.getElementById("map"));
      var params = { type: "1", year };
      var max = 0,
        min = 0;
      myMap.resize();
      api.getWenshuShowData(params).then(res => {
        // this.moveYearsList = res.data.moveYearsList;
        // if (this.timeLine3 == null) {
        //   if (res.data.moveYearsList != []) {
        //     this.time(res.data.moveYearsList); //时间轴
        //   }
        // }

        res.data.forEach(item => {
          var newArr = {};
          newArr.name = item.name
            .replace("省", "")
            .replace("市", "")
            .replace("壮族自治区", "")
            .replace("回族自治区", "")
            .replace("维吾尔自治区", "")
            .replace("自治区", "");
          newArr.value = item.value;
          mapList.push(newArr);
        });
        if (mapList.length > 0) {
          var arr = [];
          mapList.forEach((v, i) => {
            arr.push(v.value);
          });
          max = Math.max(...arr);
          min = Math.min(...arr);
        }
        var optionMap = {
          tooltip: {
            //鼠标移上去时显示悬浮框
            trigger: "item",
            // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
            // padding: 0,
            formatter: "{b}\n{c}" + "个"
          },
          visualMap: {
            //图注
            min: min,
            max: max,
            left: "left",
            top: "bottom",
            text: ["高", "低"],
            inRange: {
              color: ["#87cefa", "#dfed27", "#e6521b"]
            },
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontWeight: 400
            },
            show: true
          },

          series: [
            //整体配置
            {
              name: "中国",
              type: "map",
              mapType: "china",
              // roam: true,//缩放
              zoom: 1.2,
              label: {
                normal: {
                  show: true //省份名称
                }
              },
              data: mapList
            }
          ]
        };
        echarts.registerMap("china", chinaJson);
        myMap.setOption(optionMap);
      });
    },
    //图二-横向柱状图
    thin1(year) {
      var thin1 = echarts.init(document.getElementById("thin1"));
      thin1.resize();
      var params = { type: "2", year };
      api.getWenshuShowData(params).then(res => {
        let _data = res.data;
        _data.sort((a, b) => {
          return a.value - b.value;
        });
        option.series[0].data = _data;
        let tmpData = [];
        if (_data.length > 0) {
          for (let i = 0; i < _data.length; i++) {
            tmpData.push(_data[i].name);
          }
          option.yAxis[0].data = tmpData;
        }
        if (option && typeof option === "object") {
          thin1.setOption(option);
          window.onresize = thin1.resize;
        }
      });
      let option = {
        color: ["#1C83E8"],
        tooltip: {
          trigger: "axis",
          formatter: "{b}: {c}" + "个",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        yAxis: [
          {
            axisLine: { show: false }, //去掉线
            axisTick: { show: false }, //去掉点
            type: "category",
            data: [],
            axisLabel: {
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        xAxis: [
          {
            type: "value",
            show: false
          }
        ],
        series: [
          {
            name: "数量",
            type: "bar",
            barWidth: "30%",
            radius: "2px",
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#DFECF7",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };
    },
    //图三-横向柱状图
    thin2(year) {
      var thin2 = echarts.init(document.getElementById("thin2"));
      thin2.resize();
      var params = { type: "3", year };
      api.getWenshuShowData(params).then(res => {
        let _data = res.data;
        _data.sort((a, b) => {
          return a.value - b.value;
        });
        option.series[0].data = _data;
        let tmpData = [];
        if (_data.length > 0) {
          for (let i = 0; i < _data.length; i++) {
            tmpData.push(_data[i].name);
          }
          option.yAxis[0].data = tmpData;
        }
        if (option && typeof option === "object") {
          thin2.setOption(option);
          window.onresize = thin2.resize;
        }
      });
      let option = {
        color: ["#1C83E8"],
        tooltip: {
          trigger: "axis",
          formatter: "{b}: {c}" + "个",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        yAxis: [
          {
            axisLine: { show: false }, //去掉线
            axisTick: { show: false }, //去掉点
            type: "category",
            data: [],
            axisLabel: {
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        xAxis: [
          {
            type: "value",
            show: false
          }
        ],
        series: [
          {
            name: "数量",
            type: "bar",
            barWidth: "30%",
            radius: "2px",
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#DFECF7",
                    fontSize: 16
                  }
                }
                //  barBorderRadius: [30, 30, 30, 30],
              }
            }
          }
        ]
      };
    },
    //图四-柱状图
    graph(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph = echarts.init(document.getElementById("graph"));
      var params = { type: "4", year };
      myGraph.resize();
      api.getWenshuShowData(params).then(res => {
        let _data = res.data;
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push(v.value);
        });

        var option = {
          tooltip: {
            trigger: "axis",
            formatter: "{b}: {c}" + "个",
            axisPointer: {
              type: "shadow"
            }
          },
          grid: {
            top: "10%",
            right: "1%",
            left: "10%",
            bottom: "15%"
          },
          xAxis: [
            {
              type: "category",
              data: xAxis_data, //['湖北', '福建', '山东', '广西', '浙江', '河南', '河北']
              axisLine: {
                lineStyle: {
                  color: "rgba(255,255,255,0.12)"
                }
              },
              axisLabel: {
                margin: 10,
                color: "#e2e9ff",
                textStyle: {
                  fontSize: 12
                }
              }
            }
          ],
          yAxis: [
            {
              splitNumber: 3,
              axisLabel: {
                formatter: "{value}k",
                color: "#e2e9ff"
              },
              axisLine: {
                show: true
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: "#233e64"
                }
              }
            }
          ],
          series: [
            {
              type: "bar",
              data: series_data, //[300, 450, 770, 203, 255, 188, 156]
              barWidth: "10px",
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "rgba(0,244,255,1)" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(0,77,167,1)" // 100% 处的颜色
                      }
                    ],
                    false
                  ),
                  barBorderRadius: [30, 30, 30, 30],
                  shadowColor: "rgba(0,160,221,1)",
                  shadowBlur: 4
                }
              }
            }
          ]
        };

        myGraph.setOption(option);
      });
    },
    //图五-饼图
    graph2(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph2 = echarts.init(document.getElementById("graph2"));
      myGraph2.resize();
      var params = { type: "5", year };
      api.getWenshuShowData(params).then(res => {
        let _data = res.data;
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push({ name: v.name, value: v.value });
        });

        var option = {
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}" + "个"
          },
          legend: {
            orient: "vertical",
            //图例
            right: 40,
            top: 20,
            data: xAxis_data,
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontWeight: 400
            }
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["32%", "45%"], //半径
              avoidLabelOverlap: false,
              color: [
                "#177fe8",
                "#ef7041",
                "#a8d9ab",
                "#03aab9",
                "#88cff8",
                "#ded668",
                "#c0e272"
              ],
              label: {
                show: false,
                position: "center",
                normal: {
                  //指示线指示文字
                  show: true,
                  position: "outside",
                  formatter: "{d}%",
                  textStyle: {
                    fontWeight: 400,
                    fontSize: 12,
                    color: "#fff"
                  }
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: "12",
                  fontWeight: "bold"
                }
              },
              labelLine: {
                show: false,
                normal: {
                  //指示线指示文字
                  show: true,
                  length: 40,
                  length2: 27,
                  lineStyle: {
                    width: 1
                  }
                }
              },
              data: series_data
            }
          ]
        };
        myGraph2.setOption(option);
      });
    },
    //图六-饼图
    graph3(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph3 = echarts.init(document.getElementById("graph3"));
      myGraph3.resize();
      var params = { type: "6", year };
      api.getWenshuShowData(params).then(res => {
        let _data = res.data;
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push({ name: v.name, value: v.value });
        });

        var option = {
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}" + "个"
          },
          legend: {
            orient: "vertical",
            //图例
            right: 40,
            top: 20,
            data: xAxis_data,
            textStyle: {
              color: "#fff",
              fontSize: 12,
              fontWeight: 400
            }
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["32%", "45%"], //半径
              avoidLabelOverlap: false,
              color: [
                "#177fe8",
                "#ef7041",
                "#a8d9ab",
                "#03aab9",
                "#88cff8",
                "#ded668",
                "#c0e272"
              ],
              label: {
                show: false,
                position: "center",
                normal: {
                  //指示线指示文字
                  show: true,
                  position: "outside",
                  formatter: "{d}%",
                  textStyle: {
                    fontWeight: 400,
                    fontSize: 12,
                    color: "#fff"
                  }
                }
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: "12",
                  fontWeight: "bold"
                }
              },
              labelLine: {
                show: false,
                normal: {
                  //指示线指示文字
                  show: true,
                  length: 40,
                  length2: 27,
                  lineStyle: {
                    width: 1
                  }
                }
              },
              // itemStyle: {
              //     borderWidth: 1,
              //     borderColor: "#fff"
              // },
              data: series_data
              // data: [
              //   { value: , name: "" },
              // ]
            }
          ]
        };
        myGraph3.setOption(option);
      });
    },
    //图七-饼图
    graph4(year) {
      var xAxis_data = [];
      var series_data = [];
      var myGraph4 = echarts.init(document.getElementById("graph4"));
      myGraph4.resize();
      var params = { type: "7", year };
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}" + "个"
        },
        legend: {
          orient: "vertical",
          //图例
          right: 40,
          top: 20,
          data: xAxis_data,
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: 400
          }
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["32%", "45%"], //半径
            avoidLabelOverlap: false,
            color: [
              "#177fe8",
              "#ef7041",
              "#a8d9ab",
              "#03aab9",
              "#88cff8",
              "#ded668",
              "#c0e272"
            ],
            label: {
              show: false,
              position: "center",
              normal: {
                //指示线指示文字
                show: true,
                position: "outside",
                formatter: "{d}%",
                textStyle: {
                  fontWeight: 400,
                  fontSize: 12,
                  color: "#fff"
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false,
              normal: {
                //指示线指示文字
                show: true,
                length: 40,
                length2: 27,
                lineStyle: {
                  width: 1
                }
              }
            },
            data: series_data
          }
        ]
      };
      api.getWenshuShowData(params).then(res => {
        let _data = res.data;
        _data.forEach((v, i) => {
          xAxis_data.push(v.name);
          series_data.push({ name: v.name, value: v.value });
        });
        myGraph4.setOption(option);
      });
    },
    //图八-时间线
    time() {
      this.timeLine3 = echarts.init(document.getElementById("timeLine3"));
      let option = {
        timeline: {
          data: this.moveYearsList,
          axisType: "category",
          autoPlay: false,
          playInterval: 3000,
          left: "0",
          right: "0",
          bottom: "5%",
          width: "100%",
          //  height: null,
          label: {
            normal: {
              textStyle: {
                color: "#ddd"
              }
            },
            emphasis: {
              textStyle: {
                color: "#fff"
              }
            }
          },
          symbolSize: 10,
          lineStyle: {
            color: "#555"
          },
          checkpointStyle: {
            borderColor: "#777",
            borderWidth: 2
          },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: {
              color: "#666",
              borderColor: "#666"
            },
            emphasis: {
              color: "#aaa",
              borderColor: "#aaa"
            }
          }
        }
      };
      this.timeLine3.setOption(option);
      this.timeLine3.resize();
      this.timeLine3.on("timelinechanged", v => {
        let time = this.moveYearsList[v.currentIndex];
        time = time.substr(0, time.length - 1);
        this.map(time); //图一-中国地图
        this.thin1(time); //图二-横向柱状图
        this.thin2(time); //图三-横向柱状图
        this.graph(time); //图四-柱状图
        this.graph2(time); //图五-饼图
        this.graph3(time); //图六-饼图
        this.graph4(time); //图七-饼图
      });
    },
    init() {
      api.getTimes().then(res => {
        let year = res.data[0].slice(0, 4);
        this.moveYearsList = res.data;
        this.time();
        this.map(year); //图一-中国地图
        this.thin1(year); //图二-横向柱状图
        this.thin2(year); //图三-横向柱状图
        this.graph(year); //图四-柱状图
        this.graph2(year); //图五-饼图
        this.graph3(year); //图六-饼图
        this.graph4(year); //图七-饼图
      });
    }
  },
  beforeDestroy() {
    if (!this.timeLine3) {
      return;
    }
    this.timeLine3.dispose();
    this.timeLine3 = null;
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped lang="less">
/* scrollbar */
.rightChart::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
.rightChart::-webkit-scrollbar-thumb {
  background: #3583ed;
  border-radius: 5px;
}
.rightChart::-webkit-scrollbar-track {
  background: #dfdfdf;
  border-radius: 5px;
}
/* 针对IE的scrollbar */
.rightChart {
  scrollbar-face-color: #3583ed; /*3D表面（ThreedFace）*/
  scrollbar-highlight-color: #dfdfdf; /*3D界面的亮边（ThreedHighlight）*/
  scrollbar-shadow-color: #dfdfdf; /*3D界面的暗边（ThreedShadow）*/
  scrollbar-3dlight-color: #dfdfdf; /*亮边框*/
  scrollbar-arrow-color: #3583ed; /*方向箭头 */
  scrollbar-track-color: #dfdfdf; /*拖动区域(TrackBar)*/
  scrollbar-darkshadow-color: #dfdfdf; /*暗边框（ThreedDarkShadow）*/
}
/* 针对firefox的scrollbar */
.rightChart {
  scrollbar-color: #3583ed #dfdfdf;
  scrollbar-width: thin;
}
/* Edge 的scrollbar隐藏*/
/* .rightChart{
    -ms-overflow-style:none;
} */
// 可视化
.rightChart {
  width: auto;
  height: auto;
  margin-right: 20px;
  padding: 20px 20px 50px 20px;
  background: rgba(5, 43, 79, 0.3);
  border: 1px solid #08396a;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  .twoGraphBox {
    width: 100%;
    overflow: hidden;
    margin-bottom: 15px;

    .lefBox {
      width: 49%;
      height: 550px;
      float: left;
      .newTitle {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #08396a;
        overflow: hidden;
        .newlittleImg {
          float: left;
          img {
            width: 12px;
            height: 12px;
          }
        }
        .newword {
          margin-left: 4px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #dfecf7;
          float: left;
        }
      }
      .newgraph_box {
        width: 100%;
        height: 530px;
        margin: 0 auto;
        overflow: hidden;
      }
    }
    .cir {
      width: 30%;
      height: 550px;
      float: left;
      margin-right: 44px;
    }
    .ritBox {
      width: 49%;
      height: 550px;
      float: right;
      .newTitle {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #08396a;
        overflow: hidden;
        .newlittleImg {
          float: left;
          img {
            width: 12px;
            height: 12px;
          }
        }
        .newword {
          margin-left: 4px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #dfecf7;
          float: left;
        }
      }
      .newgraph_box {
        width: 100%;
        height: 530px;
        margin: 0 auto;
        overflow: hidden;
      }
    }
  }

  .bottom_timeLine {
    width: 100%;
    height: 100px;
    margin-top: 20px;
    #timeLine3 {
      width: 100%;
      height: 100px;
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/juEchart.vue